import { FC } from 'react';
import {
	Accordion,
	AccordionItem,
	// AccordionTrigger,
	AccordionContent,
} from '@radix-ui/react-accordion';
import { Proposal, Section } from '@/lib/types/apiTypes';
import { parseSectionsToNodes } from '@/lib/functions/designGraph';
import { useNavigate } from 'react-router';
import DesignIcons from '../DesignIcons/DesignIcons';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { setSortedNodes } from '@/redux/slices/proposalSlice';
import { Node } from '@/lib/types/graphTypes';
import { setLastSection, setLastVisitPage } from '@/redux/slices/pageSlice';

interface SectionAccordionProps {
	proposal: Proposal;
}

const SectionAccordion: FC<SectionAccordionProps> = ({ proposal }) => {
	const sortedNodes = parseSectionsToNodes(
		proposal?.sections as Section[]
	) as Node[];

	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const handleDesign = (sectionId: number) => {
		dispatch(setLastSection({ proposalId: proposal?.id, sectionId }));
		navigate(`/proposal/${proposal?.id}/section/${sectionId}/design`);
		dispatch(setLastVisitPage({ page: 'design' }));

		dispatch(setSortedNodes(sortedNodes));
	};

	return (
		<Accordion
			type="single"
			collapsible
			className="flex flex-col w-full h-full gap-3 bg-transparent-scroll"
			value={'item'}
		>
			{proposal?.sections.map((section, index) => {
				return (
					<AccordionItem value={'item-' + index} key={index}>
						<div
							className="flex hover:bg-[#EAF1FC] hover:border-[#EAF1FC] justify-between items-center gap-5 w-full bg-white py-3 px-4 relative z-20  mt-0 rounded-lg cursor-pointer border border-[#D3DDE2]  "
							onClick={() => handleDesign(section.id)}
						>
							<h2 className="font-bold text-primary dynamic-medium ">
								{section.alias}
							</h2>
						</div>
						<AccordionContent>
							<div className="flex items-start min-h-[180px] bg-white py-10 m-4 mt-[-1rem] rounded-b-3xl relative">
								<ul className="px-16 border-r border-r-gray-300 border-r-1">
									{sortedNodes.map(
										(node, index) =>
											node.data.parentId === section.id.toString() && (
												<li
													className="text-base xl:text-lg 2xl:text-xl text-[#6D7D86] mb-1 font-bold"
													key={index}
												>
													{node.data.alias}
												</li>
											)
									)}
								</ul>
								<div className="flex-1 text-base xl:text-lg 2xl:text-xl text-[#6d7d86] px-16 ">
									{section.description}
								</div>
								<DesignIcons section={section} />
							</div>
						</AccordionContent>
					</AccordionItem>
				);
			})}
		</Accordion>
	);
};

export default SectionAccordion;
